import { Component } from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import { Platform } from '@ionic/angular';
import { FirebaseAuthService } from './services/auth/firebase-auth.service';
import {LocalService} from "./services/common/local.service";
import {filter} from "rxjs/operators";
import {CommonService} from "./services/common/common.service";

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  user: any;
  membership: any;
  institution: any;
  institutionAdmin = false;
  hideMenu = false;

  public infoPages = [];

  public profilePages = [
    { title: 'Mitgliedschaft', url: '/subscription', icon: 'card' },
    { title: 'Profil', url: '/admin/profile', icon: 'person-circle' },
    { title: 'Abmelden', url: '/login', icon: 'log-out', isLogout: true },
  ];

  constructor(
    private router: Router,
    private platform: Platform,
    private firebaseAuthService: FirebaseAuthService,
    private localService: LocalService,
    private route: ActivatedRoute,
    public commonService: CommonService
  ) {
    router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    )
      .subscribe((e: NavigationEnd) => {
        if (e.url === '/login' || e.url === '/register' || e.url === '/forgot-password') {
          this.hideMenu = true;
        } else {
          this.hideMenu = false;
        }
      });
    this.listenToAuthChange();
    this.setInfoPages();
  }

  listenToAuthChange() {
    this.firebaseAuthService.isAuthenticated().subscribe((user) => {
      this.user = user;
      if (user) {
        user.getIdTokenResult().then((result) => {
          this.institutionAdmin = result.claims.institutionAdmin;
          this.initializeApp();
        }, (err) => {
          console.log('error in getting token', err);
          this.initializeApp();
        });
      } else {
        this.reset();
        this.localService.clearData();
        this.router.navigate(['login']).then();
      }
    });
  }

  reset() {
    this.membership = null;
    this.institution = null;
    this.commonService.appPages = [];
  }

  initializeApp() {
    this.localService.getMembership().then((membership) => {
      this.membership = membership;
      this.localService.getInstitution().then((institution) => {
        this.institution = institution;
        this.commonService.setAppPages(membership, this.institution, this.institutionAdmin);
      });
    });
  }

  setInfoPages() {
    this.infoPages = [];
    this.infoPages.push({ title: 'Impressum', url: 'https://lutzlotte.de/impressum', icon: 'documents' });
    this.infoPages.push({ title: 'Datenschutzbestimmungen', url: 'https://lutzlotte.de/datenschutzbestimmungen', icon: 'documents' });
    this.infoPages.push({ title: 'Nutzungsbestimmungen', url: 'https://lutzlotte.de/nutzungsbedingungen', icon: 'documents' });
  }

  logout() {
    this.firebaseAuthService.signOut().subscribe((loggedOut) => {
      //this.initializeApp();
      // this.router.navigateByUrl('/login').then();
    });
  }

  openUrl(url: string) {
    window.open(url, "_blank");
  }
}
